import { useMutation } from "@tanstack/react-query";
import { addPodToCart } from "src/api/pod";
const useAddPodToCart = ()=>{
    return useMutation({
        mutationFn: (params)=>addPodToCart(params)
    });
};
export default useAddPodToCart;
